import * as React from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/timeoff/pages/dashboard/RootPage'))
const NewLeavePage = React.lazy(() => import('modules/timeoff/pages/dashboard/NewLeavePage'))

const dashboardRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.dashboard.leaves.path,
      element: <RootPage />,
      children: [
        {
          path: navigation.dashboard.leaves.new.path,
          element: <NewLeavePage />,
        },
      ],
    },
  ]
}

export default dashboardRoutes
